// src/pages/Delivery.js
import React, { useState, useRef, useEffect } from 'react';
import customers from './conf/Customers';
import CustomerStyles from './conf/CustomerStyles';
import { showBootboxModal } from './conf/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import * as global from './conf/global';
import Shipment from './conf/Shipment';
import { ReactBootboxModal } from './conf/utils';
import WebcamCapture from './conf/WebcamCapture';
import { addItem } from './conf/bdd';
import { sendData } from './conf/Webservice';
import generateDeviceId from './conf/device';
import { writeLogMsg } from './conf/log';

function Delivery() {
  const [selectedCustomer, setSelectedCustomer] = useState(customers.shortlist.find(item => item.id.toString() === localStorage.getItem('customer')) || customers.shortlist.find(item => item.label === global.APP_DEFAULT_CUSTOMER) || customers.shortlist[0]);
    CustomerStyles(selectedCustomer);

    const { t } = useTranslation();
    const navigation = useNavigate();
    const location = useLocation();
    const { state } = location;

    const [selectedStatus, setSelectedStatus] = useState('');
    const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
    const [isCameraModalOpen, setIsCameraModalOpen] = useState(false);
    const [indexCamera, setIndexCamera] = useState(-1);
    const [cameraResult, setCameraResult] = useState('');
    const [showPhoto, setShowPhoto] = useState('');
    const [shipment, setShipment] = useState(new Shipment());
    const [shipmentSaved, setShipmentSaved] = useState(new Shipment());
    const [bddIndexValue, setBddIndexValue] = useState(parseInt(localStorage.getItem('bddIndex'), 10) || 1);
    const [loading, setLoading] = useState(false);
    const [deviceID] = useState(localStorage.getItem('deviceID') || generateDeviceId());
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const cameraResultRef = useRef(null);

    /* ------------------------------------------------------------
       SHIPMENT LOAD
    -------------------------------------------------------------*/
    useEffect(() => {
        writeLogMsg('Delivery page'); 
        localStorage.setItem('deviceID', deviceID); 
        writeLogMsg('Delivery: Device ID:', deviceID); 
        // Vérifiez si l'état de l'expédition est présent 
        if (state && state.shipment) { 
            // Chargez l'expédition à partir de l'état 
            setShipment(Object.assign(new Shipment(), state.shipment)); 
            setShipmentSaved(Object.assign(new Shipment(), state.shipment)); 
            writeLogMsg('Delivery: Shipment loaded: ', state.shipment); 
        } else { 
            writeLogMsg('Delivery: No shipment found, redirecting to Home'); 
            navigation("/"); 
        }
    }, [state, navigation, deviceID]);

    /* ------------------------------------------------------------
       FUNCTIONS
    -------------------------------------------------------------*/

    useEffect(() => {
        cameraResultRef.current = cameraResult;
    }, [cameraResult]);
    
    const handleCameraResult = (result) => {
        setCameraResult(result);
    }
    
    const handleMapsClick = () => {
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${shipment.getAddress()}`, "_blank");
    };

    const handleDialClick = () => {
        window.location.href = `tel:${shipment.PhoneNumber}`;
    };

    const handleChangeStatus = (e) => {
        setSelectedStatus(e.target.id);
        //saveDraft();
    };

    const openCameraModal = (i) => {
        setIndexCamera(i);
        writeLogMsg('Delivery: Open camera modal for index', i);
        setIsCameraModalOpen(true);
    };

    const closeCameraModal = () => {
        setIndexCamera(-1);
        setIsCameraModalOpen(false);
    };

    const handleCameraValidate = (data) => {
        if (indexCamera === -1) return;
        // Accès à la valeur via ref
        if (cameraResultRef.current) {
            if (indexCamera === "s") {
                shipment.Signature = cameraResultRef.current;
            } else {
                shipment.FreePictureList[indexCamera] = cameraResultRef.current;
            }
        }
        writeLogMsg('Delivery: shipment after camera', shipment);

        // Réinitialisation pour nouvelle ouverture
        setCameraResult(null);
        //shipment.FreePictureList[indexCamera] = data;
        //saveDraft();
        closeCameraModal();
    };

    const openPhotoModal = (index) => {
        requestAnimationFrame(() => {
            try {
                const status = navigator.permissions.query({ name: 'camera' });
                writeLogMsg('Delivery: openPhotoModal: camera permission state:', status.state);
            } catch (err) {
                console.error('Permission query failed:', err);
            }
            if ("mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices)
            {
                navigator.mediaDevices.getUserMedia({ video: true })
                .then((stream) => {
                    stream.getTracks().forEach(track => track.stop());
                    setIndexCamera(index);
                    writeLogMsg('Delivery: Open camera modal for index', '' + index);
                    if (index === "s") {
                        setShowPhoto(shipment.Signature);
                    } else {
                        setShowPhoto(shipment.FreePictureList[index]);
                    }
                    setIsPhotoModalOpen(true);
                })
                .catch((err) => {
                    console.error('Delivery: openPhotoModal: getUserMedia failed:', err.name, err.message);
                    showBootboxModal(t('PERMISSION_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                });
            } else {
                showBootboxModal(t('NAVIGATOR_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
            }
        });
    };
  
    const closePhotoModal = () => {
        setShowPhoto('');
        setIndexCamera(-1);
        setIsPhotoModalOpen(false);
    };
  
    const handlePhotoDelete = () => {
        showBootboxModal(
            t('DELETE_MSG'),
            t('DELETE_TITLE'),
            t('DELETE_BTNOK'),
            t('DELETE_BTNCANCEL'),
            () => {
                writeLogMsg('Delivery: Deleting photo at index', ''+indexCamera);
                if (indexCamera === -1) return;
                if (indexCamera === "s") {
                    shipment.Signature = "";
                } else {
                    shipment.FreePictureList[indexCamera] = "";
                }
                //saveDraft();
                closePhotoModal();
            },
            () => {
                writeLogMsg('Delivery: Photo deletion cancelled');
                closePhotoModal();
            });
    };

    const handleValidDeliveryGeolocation = () => {
        requestAnimationFrame(() => {
            setLoading(true);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    writeLogMsg('Delivery: Geolocation:', position);
                    shipment.Geolocation.latitude = position.coords.latitude;
                    shipment.Geolocation.longitude = position.coords.longitude;
                    shipment.Geolocation.date = position.timestamp;
                    shipment.Geolocation.accuracy = position.coords.accuracy;
                    handleValidDelivery();
                }, function (error) {
                    setLoading(false);
                    console.error('Delivery: Geolocation error:', error);
                    showBootboxModal(t('PERMISSION_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                    return; 
                });
            } else {
                setLoading(false);
                console.error('Delivery: Geolocation not supported');
                showBootboxModal(t('NAVIGATOR_ERROR'), t('POPUP_ALERT_TITLE'), t('POPUP_ALERT_BTNOK'));
                return; 
            }
        });
    };

    const handleValidDelivery = async () => {
        // Logic for validating delivery
        if (selectedStatus === "") {
            setLoading(false);
            showBootboxModal(t('ERROR_STATUS_MSG'), t('ERROR_STATUS_TITLE'), t('ERROR_STATUS_BTNOK'));
            return; 
        }
        var signataire = document.getElementById("txtSignatory").value;
        if (signataire === "") {
            setLoading(false);
            showBootboxModal(t('ERROR_SIGNATORY_MSG'), t('ERROR_SIGNATORY_TITLE'), t('ERROR_SIGNATORY_BTNOK'));
            return;
        }
        if (shipment.signatureExits() === false) {
            setLoading(false);
            showBootboxModal(t('ERROR_SIGNATURE_MSG'), t('ERROR_SIGNATURE_TITLE'), t('ERROR_SIGNATURE_BTNOK'));
            return;
        }
        var comments = document.getElementById("txtComments").value;
        var status = selectedStatus;
        var date = new Date();

        shipment.DBIndex = String(bddIndexValue).padStart(4, '0');
        shipment.Status = status;
        shipment.Comments = comments;
        shipment.SignedName = signataire;
        shipment.ValidationDate = date.getTime();
        shipment.DeviceID = deviceID;
        shipment.Language = localStorage.getItem('language') || 'fr'; 
        shipment.Sent = false;
        if (selectedCustomer.email)
        {
            shipment.Email = localStorage.getItem('userEmail');
        }
        shipment.Customer.shipRegEx = '';
        shipment.Customer.colRegEx = '';

        // Update index
        var newBddIndexValue = bddIndexValue + 1;
        if (newBddIndexValue > 9999) newBddIndexValue = 1;
        localStorage.setItem('bddIndex', newBddIndexValue);
        setBddIndexValue(newBddIndexValue);
        
        sendData('Delivery', shipment)
        .catch((error) => {
            shipment.Sent = false;
            console.error('Delivery: Error:', error , ' while sending shipment:', shipment);
        })
        .then(async () => {;

            writeLogMsg('Delivery: Shipment after validation', shipment);

            // Save shipment to local storage
            await addItem(shipment);
            writeLogMsg('Delivery: Shipment saved to local storage', shipment);

            setLoading(false);
            // Go to next screen
            // Sérialisation
            const serializedShipment = {
                ...shipment
            };
            //localStorage.removeItem("deliveryDraft");
            navigation("/Validation", { state: { shipment: serializedShipment } });
        });
    };

    useEffect(() => {
        const handleOnline = async () => {
        setIsOnline(true);
        writeLogMsg('Delivery: handleOnline: Vous êtes en ligne !');

        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'P4C_SYNC_ONLINE' });
            writeLogMsg('Delivery: handleOnline: Envoi du message de synchronisation au service worker');
        } else {
            writeLogMsg('Delivery: handleOnline: Service worker non disponible ou pas contrôleur actif');
        }

        };

        window.addEventListener('online', handleOnline);

        return () => {
        window.removeEventListener('online', handleOnline);
        };
    }, []);

    const isAppleDevice = () => /ipad|iphone|ios/.test(navigator.userAgent.toLowerCase());

    /* ------------------------------------------------------------
       AUTO-SAVE RESTORE
    -------------------------------------------------------------*/
    /*
    useEffect(() => {
        const raw = localStorage.getItem("deliveryDraft");
        if (!raw) return;

        writeLogMsg("Delivery: restoring draft from cache");

        const draft = JSON.parse(raw);
        setSelectedStatus(draft.status);

        shipment.FreePictureList = draft.pictures || [];
        shipment.Signature = draft.signature || "";

        setTimeout(() => {
            const txtC = document.getElementById("txtComments");
            const txtS = document.getElementById("txtSignatory");
            if (txtC) txtC.value = draft.comments;
            if (txtS) txtS.value = draft.signatory;
        });
    }, []);

    const saveDraft = () => {
        
        const draft = {
            status: selectedStatus,
            comments: document.getElementById("txtComments")?.value || "",
            signatory: document.getElementById("txtSignatory")?.value || "",
            pictures: [...shipment.FreePictureList],
            signature: shipment.Signature,
        };
        localStorage.setItem("deliveryDraft", JSON.stringify(draft));
        writeLogMsg("Delivery: draft saved");
        
    };
    */
    /* ------------------------------------------------------------
       BACK POPUP LOCK 
    -------------------------------------------------------------*/
    const [backLocked, setBackLocked] = useState(false);

    useEffect(() => {
        window.__BACK_POPUP_OPEN__ = backLocked;
    }, [backLocked]);

    const handleCancel = () => {
        if (backLocked) return; // popup already opened
        //saveDraft();
        setBackLocked(true);

        showBootboxModal(
            t('BACK_MSG'),
            t('BACK_TITLE'),
            t('BACK_BTNOK'),
            t('BACK_BTNCANCEL'),
            () => {
                setBackLocked(false);
                //localStorage.removeItem("deliveryDraft");
                navigation('/');
            },
            () => {
                setBackLocked(false);
            }
        );
    };

    const handleBack = () => {
        if (backLocked) return; // popup already opened
        //saveDraft();
        setBackLocked(true);

        showBootboxModal(
            t('BACK_MSG'),
            t('BACK_TITLE'),
            t('BACK_BTNOK'),
            t('BACK_BTNCANCEL'),
            () => {
                setBackLocked(false);
                //localStorage.removeItem("deliveryDraft");
                if (getBarcodeType(shipmentSaved.ShipmentNumber) === global.SCREEN_CONFIRMATION) {
                    shipmentSaved.ShipmentType = global.SCREEN_CONFIRMATION;
                    // Sérialisation
                    const serializedShipment = {
                        ...shipmentSaved
                    };
                    navigation('/Confirmation', { state: { shipment: serializedShipment, chooseMessageShipment: true } }); //screen for choose between delivery & collect
                }
                else {
                    navigation('/');
                }
            },
            () => {
                setBackLocked(false);
            }
        );
    };

    /**
     * Get barcode type for current customer
     */
    const getBarcodeType = (barcode) => {
        var astrBarcodeType = "";
        var aoShipRegEx = new RegExp(selectedCustomer.shipRegEx);
        var aoColRegEx = new RegExp(selectedCustomer.colRegEx);

        // Check if collect is activated for current customer
        if (isCollectActivated()) {
            // Check if Barcode is valide with RegExp of Delivery
            if (aoShipRegEx.test(barcode)) {
                // Check if Barcode is valide with RegExp of Collect
                if (aoColRegEx.test(barcode)) {
                    // Barcode RegEx is valide with Delivery & Collect
                    // Impossible to choose the type
                    astrBarcodeType = global.SCREEN_CONFIRMATION;
                }
                else {
                    astrBarcodeType = global.SHIP_TYPE_DEL;
                }
            }
            else {
                // Check if Barcode is valide with RegExp of Collect
                if (aoColRegEx.test(barcode)) {
                    astrBarcodeType = global.SHIP_TYPE_COL;
                }
            }
            }
        else {
            // Check if Barcode is valide with RegExp of Delivery
            if (aoShipRegEx.test(barcode)) {
                astrBarcodeType = global.SHIP_TYPE_DEL;
            }
        }
        return astrBarcodeType;
    };

    /**
     * Check if current collect is activated for customer (check status list)
     */
    var isCollectActivated = () => {
        var abActivated = false;
        if (selectedCustomer !== null && selectedCustomer !== "") {
            for (var i = 0; i < selectedCustomer.statusList.length && !abActivated; i++) {
                abActivated = (selectedCustomer.statusList[i].type === global.SHIP_TYPE_COL);
            }
        }
        return abActivated;
    };

    /* ------------------------------------------------------------
       APP BACK EVENT
    -------------------------------------------------------------*/
    useEffect(() => {
        const handler = () => {
            handleBack();
        };
        window.addEventListener("app-back", handler);
        return () => window.removeEventListener("app-back", handler);
    }, [selectedStatus, shipment]);

    /* ------------------------------------------------------------
       UI
    -------------------------------------------------------------*/
    return (
        <div id="mainDiv" style={{position : 'static'}} >
            <div>
                {/*  Navigation bar */}
                <nav className="navbar navbar-expand-lg navbar-fixed-top navbar-default col-sm-12" role="navigation" style={{ display: 'flow-root' }}>
                    {/*  Customer logo */}
                    <img 
                        src={`assets/images/xhdpi/logo-header-${selectedCustomer.name}.png`}
                        srcSet={`assets/images/mdpi/logo-header-${selectedCustomer.name}.png 320w,
                                assets/images/hdpi/logo-header-${selectedCustomer.name}.png 480w,
                                assets/images/xhdpi/logo-header-${selectedCustomer.name}.png 640w,
                                assets/images/xxhdpi/logo-header-${selectedCustomer.name}.png 960w`}
                        alt={`Logo ${selectedCustomer.name}`} 
                        className='col-6'/>
                    {/*  Shipment Number */}
                    {/*<label className='col-12'>ID : {`${shipment.ShipmentNumber}`}</label>*/}
                    <label className='col-12 navbar-default bold justify-content-center' style={{color: 'white'}}>ID : {`${shipment.ShipmentNumber}`}</label>
                </nav>
                {/*  Delivery Tab */}
                <div class="navbar-default">
                    <div className="navbar col-6 bold pl-4 bg-white justify-content-center menu-color" style={{borderTopRightRadius: '5px'}}>
                        {shipment.ShipmentType === global.SHIP_TYPE_DEL ? t('DELIVERY_TITLE') : t('COLLECT_TITLE')}
                    </div>
                    <div className="col-6 navbar-default"></div>
                </div>

                {/* Delivery infos */}
                <div className="col-sm-10 col-lg-8 mx-auto">
                    <div className="form-group">
                        {/*  Tabs */}
                        <div id="deliveryTab">
                            <div>
                                <div className="row delinfo col-12">
                                    {/*  Address */}
                                    <div className="deliveryAddress col-10">
                                        <label id="deliveryAddress" style={{whiteSpace : 'pre-wrap'}}>{shipment.AddressDefined ? shipment.getDeliveryLabel() : t('MSG_NO_INFO')}</label>
                                    </div>
                                    {/*  Buttons Maps & Phone */}
                                    <div className="col-2 align-self-center deliveryBtn">
                                        <button type="button" className="btn btn-info btn-del" onClick={handleMapsClick} style={{backgroundColor: '#b5b5b5', borderColor: '#919191'}}>
                                            <span className="glyphicon glyphicon-map-marker"></span>
                                        </button>
                                        { isAppleDevice() ? null : (
                                        <button type="button" className="btn btn-info btn-del" onClick={handleDialClick} style={{backgroundColor: '#b5b5b5', borderColor: '#919191'}}>
                                            <span className="glyphicon glyphicon-earphone"></span>
                                        </button>
                                        )}
                                    </div>
                                </div>
                                {/*  Status radio button list */}
                                <div className='row'>
                                    <div className="btn-group blocks col-12 p-0">
                                        {selectedCustomer.statusList.filter(item => item.type === shipment.ShipmentType).map((status) => (
                                            <div key={status.code} className="btn btn-default btn-radio p-0" style={{marginLeft: '1px', marginRight: '1px'}}>
                                                <input
                                                    type="radio"
                                                    id={status.code}
                                                    name="toggleOptions"
                                                    value={t(status.lang)}
                                                    checked={selectedStatus === status.code}
                                                    onChange={handleChangeStatus}
                                                />
                                                <label 
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        padding: '10px 10px',
                                                        margin: '0',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        borderRadius: '3px'
                                                    }}
                                                    htmlFor={status.code}>{t(status.lang)}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*  Delivery comments */}
                        <div className="row form-group">
                            <textarea id="txtComments" className="form-control" rows={3} maxLength={global.COMMENT_LENGTH} placeholder={t('DELIVERY_COMMENTS_TITLE')}></textarea>
                        </div>
                        {/*  Delivery signatory */}
                        <div className="row form-group">
                            <input type="text" id="txtSignatory" ng-model="shipment.astrSignedName" className="form-control" my-maxlength="20" placeholder={t('DELIVERY_SIGNATORY_TITLE')}/>
                        </div>

                        {/*  Delivery pictures */}
                        <div className="row jumbotron pictures">
                            {/*  Delivery free pictures */}
                            <div className="col-8 text-center">
                                <label>{t('BTN_FREE_PHOTO')}</label>
                                {!shipment.freePictureExits(0) && (
                                    <button  className="btn btn-default btn-secondary btn-del" onClick={() => openCameraModal(0)}>
                                        <span className="glyphicon glyphicon-del glyphicon-camera"></span>
                                    </button>
                                )}
                                {shipment.freePictureExits(0) && (
                                    <button id="btnpicture0" className="btn btn-default btn-secondary btn-del thumbnail open-AddBookDialog" onClick={() => openPhotoModal(0)}>
                                        <img id="picture0" className='img-adjust' src={shipment.FreePictureList[0]}/>
                                    </button>
                                )}
                                {!shipment.freePictureExits(1) && (
                                    <button  className="btn btn-default btn-secondary btn-del" onClick={() => openCameraModal(1)}>
                                        <span className="glyphicon glyphicon-del glyphicon-camera"></span>
                                    </button>
                                )}
                                {shipment.freePictureExits(1) && (
                                    <button id="btnpicture1" className="btn btn-default btn-secondary btn-del thumbnail open-AddBookDialog" onClick={() => openPhotoModal(1)}>
                                        <img id="picture1" className='img-adjust' src={shipment.FreePictureList[1]}/>
                                    </button>
                                )}
                                {!shipment.freePictureExits(2) && (
                                    <button  className="btn btn-default btn-secondary btn-del" onClick={() => openCameraModal(2)}>
                                    <span className="glyphicon glyphicon-del glyphicon-camera"></span>
                                </button>
                                )}
                                {shipment.freePictureExits(2) && (
                                    <button id="btnpicture2" className="btn btn-default btn-secondary btn-del thumbnail open-AddBookDialog" onClick={() => openPhotoModal(2)}>
                                        <img id="picture2" className='img-adjust' src={shipment.FreePictureList[2]}/>
                                    </button>
                                )}
                            </div>

                            {/*  Delivery signature */}
                            <div className="col-4 text-center">
                                <label>{t('BTN_SIGNATURE_PHOTO')}</label>
                                {!shipment.signatureExits() && (
                                    <button className="btn btn-default btn-secondary btn-del" onClick={() => openCameraModal("s")}>
                                        <span className="glyphicon glyphicon-del glyphicon-camera"></span>
                                    </button>
                                )}
                                {shipment.signatureExits() && (
                                    <button className="btn btn-default btn-secondary btn-del thumbnail open-AddBookDialog" onClick={() => openPhotoModal("s")}>
                                        <img id="signature" className='img-adjust' src={shipment.Signature}/>
                                    </button>
                                )}
                            </div>
                            <ReactBootboxModal
                                isOpen={isCameraModalOpen}
                                onClose={closeCameraModal}
                                onConfirm={handleCameraValidate}
                                onCancel={closeCameraModal}
                                showCancel={true}
                                title={t('DELIVERY_TITLE_CAMERA')}
                                comfirmLabel={t('DELIVERY_COMFIRM_CAMERA')}
                                cancelLabel={t('DELIVERY_CANCEL_CAMERA')}>
                                <WebcamCapture
                                    onCapture={(imgSrc) => {handleCameraResult(imgSrc)}}
                                />
                            </ReactBootboxModal>
                            <ReactBootboxModal
                                isOpen={isPhotoModalOpen}
                                onClose={closePhotoModal}
                                onConfirm={closePhotoModal}
                                onDelete={handlePhotoDelete}
                                showDelete={true}
                                title={t('DELIVERY_TITLE_PHOTO')}
                                confirmLabel={t('DELIVERY_COMFIRM_PHOTO')}
                                deleteLabel={t('DELIVERY_DELETE_PHOTO')}>
                                <div className="text-center">
                                    <img src={showPhoto} alt="Photo" className='img-adjust'/>
                                </div>
                            </ReactBootboxModal>
                            {loading && (
                            <div className="overlay">
                                <div className="loader">
                                    <img src="/assets/images/loader.gif" alt="Loading..." /> {/* Remplacez par l'URL de votre image de chargement */}
                                </div>
                            </div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        {/*  Cancel button */}
                        <div className="col-6 btn-del-val">
                            <button id="btnCancelDelivery" onClick={handleCancel} className="btn-block btn btn-primary">{t('BTN_CANCEL_DELIVERY')}</button>
                        </div>

                        {/*  Validate button */}
                        <div className="col-6 btn-del-val">
                            <button id="btnValidDelivery" onClick={handleValidDeliveryGeolocation} className="btn-block btn btn-default">{t('BTN_VALID_DELIVERY')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Delivery;
